'use client'
import styled, { keyframes } from "styled-components";
import colors from "common/theme/saasModern/colors";
import { saasModernTheme } from "common/theme/saasModern";
import bannerImg from "common/assets/image/saasModern/banner-acculturation.webp"
import Link from "next/link";

export const Main = styled.div`
  scroll-behavior: smooth
`

export const Container = styled.div`
  width: 60%;
  margin: 0 auto;
  position: relative;
  z-index: 2; /* Above the background image */
  @media (max-width: 1540px) {
    width: 80%;
  }
  @media (max-width: 1240px) {
    width: 90%;
  }
  @media (max-width: 768px) {
    width: 80%;
  }
  @media (max-width: 450px) {
    width: 95%;
  }
`

export const GradientText = styled.span`
  background: linear-gradient(to right, #3b82f6, #ec4899, #f97316);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`
export const HeroContainer = styled.div`
  padding: 8rem 1rem;
  text-align: center;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  z-index: 1; /* Below the text */
  @media (max-width: 450px) {
    background-size: contain;
  }
`;

export const BackgroundHeroContainer = styled.div`
  background-size: cover;
  background-position-y: 110%;
  background-repeat: no-repeat;
  background-color: lighten(#020934, 0%);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.2; /* Background image is semi-transparent */
  z-index: 1; /* Below the text */
`

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 900;
  color: black;
  margin-top: 24px;
  margin-bottom: 24px ;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.div`
  color: black;
  font-size: 1.125rem;
  margin: 0 auto 2rem;
`;

export const TextCenter = styled.div`
  text-align: center;
`;

export const BoostContainer = styled.section`
  text-align: center;
`;

export const ContentWrapper = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`;

export const Description = styled.div`
  color: black;
  font-size: 1rem;
  margin: 0 auto;
`;

export const WhyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  margin-bottom: 2rem;
  margin-top: 4rem;
  @media (max-width: 968px) {
    flex-direction: column;
    gap: 2rem;
    padding: 2rem 1rem;
  }
`;

export const BackgroundLinearContainer = styled.div`
  background: linear-gradient(180deg, rgba(16, 152, 247, 0.05) 0%, rgba(255, 110, 114, 0.05) 100%);
  padding-top:5rem;
  padding-bottom:5rem;
  @media (max-width: 450px) {
    padding-top:2rem;
    padding-bottom:2rem;
  }
`;

export const SliceContainer = styled.div`
  padding-top:5rem;
  padding-bottom:${props => props.paddingBottom ? props.paddingBottom : 5}rem;
  @media (max-width: 450px) {
    padding-top:2rem;
    padding-bottom:2rem;
  }
`;

export const WhyImageWrapper = styled.div`
  flex: 1;
  img {
    width: 100%;
    height: auto;
    border-radius: ${saasModernTheme.radius[4]}px;
    overflow: hidden;
  }
`;

export const WhyContentWrapper = styled.div`
  flex:1;
  display: flex;
  flex-direction: column;
`;


export const WhyContentTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 900;
  color: black;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const BenefitsContainer = styled.section`
  padding-top: 4rem;
  padding-bottom: 1rem;
`;

export const BenefitsGrid = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
`;

  export const BenefitCard = styled.div`
    padding: 2rem;
    flex: 1 25%;
    border-radius: ${saasModernTheme.radius[4]}px;
    max-width: 25%;
    position: relative;
    cursor: pointer;
    background: linear-gradient(180deg, rgba(16, 152, 247, 0.05) 0%, rgba(255, 110, 114, 0.05) 100%);
    transition: border 0.3s ease-in-out;  // added transition for border
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      inset: 0;
    border-radius: ${saasModernTheme.radius[4]}px;
      padding: 2px;
      background: linear-gradient(to right, #ec4899, #3b82f6);
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      opacity: 0;  // start with transparent
      transition: opacity 0.3s ease-in-out;  // added transition for opacity
    }
  
    &:hover {
      &::before {
        background-position: 100% 100%;  // shift the gradient on hover
        opacity: 1;  // fade in border
      }
    }

    @media (max-width: 640px) {
      max-width: 100%;
    }
`;

export const BenefitCardTitle = styled.h3`
  color: black;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const BenefitCardDescription = styled.p`
  color: #94a3b8;
  font-size: 0.875rem;
  line-height: 1.6;
`;


export const ProgramContainer = styled.section`
padding-bottom: 4rem;
`;


export const  ProgramCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const  ProgramCard = styled.div`
    border-radius: ${saasModernTheme.radius[4]}px;
  padding: 2rem;
  display: flex;
  gap: 0.8rem;
  flex-direction: column;
  align-items: flex-start;
  justify-content:flex-start;
  background: linear-gradient(180deg, rgba(16, 152, 247, 0.05) 0%, rgba(255, 110, 114, 0.05) 100%);
`;

export const  ProgramIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
`;

export const  ProgramCardTitle = styled.h3`
  color: black;
  font-size: 1.125rem;
  font-weight: bold;
  margin: 0;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

export const Bullet = styled.span`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  background: linear-gradient(to right, #3b82f6, #ec4899);
    border-radius: ${saasModernTheme.radius[4]}px;
`;

export const FeatureContent = styled.div`
  flex: 1;
  padding: 0;
  margin: 0;
  & > p{
    padding: 0;
    margin: 0;
  }
  color: ${colors.black};
`;
 
 
export const PillarsPillarsContainer = styled.section`
  position: relative;
  @media (max-width: 768px) {
    padding:  0;
    padding-bottom : 24px;
  }
`;

export const PillarsSlideContainer = styled.div`
    border-radius: ${saasModernTheme.radius[4]}px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    height: auto;
  }
`;
 
export const PillarsSlideContent = styled.div`
  position: relative;
  border-radius: ${saasModernTheme.radius[4]}px;
  background-image: url(${props => props.bgImage});
  width: 99%;
  background-size: cover;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: ${saasModernTheme.radius[4]}px;
    overflow: hidden;
    padding: 5px;
    overflow: hidden;
    background: linear-gradient(to right, #3b82f6, #ec4899, #f97316);
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
  @media (max-width: 768px) {
    display: block;
  }
`;

export const PillarsTextContent = styled.div`
  flex-grow: 1;
  color: white;
  padding: 1rem;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const PillarsSlideTitle = styled.h3`
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
`;

export const PillarsDescription = styled.p`
  color: ${colors.white};
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

export const StartContainer = styled.section`
  padding: 4rem 1rem;
  margin: 0 auto;
`;

export const StartGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const StartColumn = styled.div`
  background: rgba(255, 255, 255, 0.05);
    border-radius: ${saasModernTheme.radius[4]}px;
  padding: 1rem 2rem;
  position: relative;
`;

export const StartColumnTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: black;
  height: 60px;
`;

export const StartDescription = styled.p`
  color: ${colors.black};
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 4rem;
  a {
    text-decoration: none;
    color: white;
  }
`;

export const StartButtonWrapper = styled(Link)`
  background-color: ${colors.redSecondary};
  padding: 8px;
  text-transform: capitalize;
  border-radius: ${saasModernTheme.radius[3]}px;
  color: ${colors.white};
  float: left;
  text-decoration: none;
  position: absolute;
  bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
`;

export const ReferencesContainer = styled.section`
  padding: 4rem 1rem;
  margin: 0 auto;
`;

export const ReferencesTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

 

export const ReferencesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
  
  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ReferencesCard = styled.div`
  background-color: ${props => props.bgColor};
    border-radius: ${saasModernTheme.radius[4]}px;
  padding: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;
 
export const CenterElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
   @media (max-width: 640px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;